import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import {Product} from "../../models/product";
import {VoucherTemplate} from "../../models/voucherTemplate";

@Injectable({
    providedIn: 'root'
})
export class AddVoucherEmitterService {

    invokeAddVoucher = new EventEmitter<VoucherTemplate>();
    subsAddVoucher: Subscription;

    constructor() { }

    onAddVoucher(voucher: VoucherTemplate) {
        this.invokeAddVoucher.emit(voucher);
    }
}
